<ng-container *transloco="let t; prefix: 'core.pwaPrompt'">
  @if (data.mobileType === 'android') {
    <mat-toolbar color="primary" class="android-prompt">
      <button mat-button (click)="installPwa()">{{ t('install') }}</button>
      <button mat-icon-button (click)="close()" [attr.aria-label]="t('close')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  }

  @if (data.mobileType === 'ios') {
    <div class="ios-prompt">
      <button class="close-ios-inv" mat-button color="primary" (click)="close()" [attr.aria-label]="t('close')">
        <mat-icon>close</mat-icon>
      </button>
      <div>{{ t('iosInstructions') }}</div>
      <div>
        <!-- Decorative: the instruction text above names both buttons -->
        <img src="./assets/icons/ios-menu-btn.png" class="pwa-icon" alt="" /> <mat-icon>navigate_next</mat-icon>
        <img src="./assets/icons/ios-add-btn.png" class="pwa-icon" alt="" />
      </div>
    </div>
  }
</ng-container>
